import { Injectable, isDevMode } from '@angular/core';
import { EMPTY, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { LicensesDaoService } from 'src/app/dao/licenses-dao-service/licenses-dao.service';
import { LicenseDevice } from 'src/app/models/licenses-model/license-device.model';
import { License } from 'src/app/models/licenses-model/license.model';
import { UserService } from '../user-service/user.service';
import { UserStorageService } from '../user-storage-service/user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class LicensesService {

  accessToken = 'ACT';
  filterLicensesListener = new Subject<any>();
  searchLicensesListener = new Subject<any>();
  exportLicensesListener = new Subject<any>();

  constructor(
    private licensesDaoService: LicensesDaoService,
    private userStorageService: UserStorageService,
    private userService: UserService) { }

  public getLicenses() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.licensesDaoService.getLicenses(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const licenses = new Array<License>();
          o['data']['licenseList'].forEach(
            (l) => {
              const license = new License();
              Object.assign(license, l);
              license.DeviceList = l['deviceList'] ? l['deviceList'].map(device => Object.assign(new LicenseDevice(), device)) : [];
              licenses.push(license);
            }
          );
          return licenses;
        })
      );
    }
    return EMPTY;
  }

  public filterLicenses(opts) {
    this.filterLicensesListener.next(opts);
  }

  public filterLicensesListen() {
    return this.filterLicensesListener.asObservable();
  }

  public searchLicenses(key) {
    this.searchLicensesListener.next(key);
  }

  public searchLicensesListen() {
    return this.searchLicensesListener.asObservable();
  }

  public exportLicenses() {
    this.exportLicensesListener.next();
  }

  public exportLicensesListen() {
    return this.exportLicensesListener.asObservable();
  }

}
